// extracted by mini-css-extract-plugin
export default {"subscribed":"L3uYQ","bordered":"AncDz","icon":"Ggf7a","text":"LpFFz","iconSubscribe":"xj53T"};